import React from 'react';
import PropTypes from 'prop-types'
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import { SwiperWrap } from './swiper.style'

const SwiperSlider = ({ children, settings, ...props }) => {
    const [paginationEl, setPaginationEl] = React.useState(null);

    const sliderSettings = settings?.pagination ? {
        ...settings,
        pagination: {
            ...settings.pagination,
            el: paginationEl
        }
    } : settings;

    return (
        <SwiperWrap {...props}>
            <Swiper modules={[Pagination, Autoplay, Navigation]} {...sliderSettings}>
                {children}
            </Swiper>
            {settings?.pagination && <div className="swiper-pagination" ref={(node) => setPaginationEl(node)} />}
        </SwiperWrap>
    )
}

export { SwiperSlide };

SwiperSlider.propTypes = {
    children: PropTypes.node.isRequired,
    settings: PropTypes.object
}

SwiperSlider.defaultProps = {
    settings: {
        slidesPerView: 4,
        loop: true,
        speed: 1000,
        spaceBetween: 0,
        autoplay: false,
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        }
    }
}

export default SwiperSlider; 